"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRequest = handleRequest;
const buffer_1 = require("buffer");
const logger = __importStar(require("../logger"));
const serialization_1 = require("../gtx/serialization");
const enums_1 = require("./enums");
function createTimeoutController(timeout) {
    if (!timeout)
        return { controller: undefined, timeoutId: undefined };
    const controller = new AbortController();
    const timeoutError = new Error(`Request timeout after ${timeout}ms`);
    timeoutError.name = 'TimeoutError';
    const timeoutId = setTimeout(() => controller.abort(timeoutError), timeout);
    return { controller, timeoutId };
}
function handleRequest(method, path, endpoint, timeout, postObject) {
    return __awaiter(this, void 0, void 0, function* () {
        if (method == enums_1.Method.GET) {
            return yield get(path, endpoint, timeout);
        }
        else {
            return yield post(path, endpoint, timeout, postObject);
        }
    });
}
/**
 * Sends request to get data from a given API endpoint.
 * @param path API endpoint of Rell backend
 * @param endpoint
 * @param timeout
 */
function get(path, endpoint, timeout) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug(`GET URL ${new URL(path, endpoint).href}`);
        try {
            const { controller, timeoutId } = createTimeoutController(timeout);
            const response = yield fetch(new URL(path, endpoint).href, {
                signal: controller === null || controller === void 0 ? void 0 : controller.signal,
            });
            if (timeoutId)
                clearTimeout(timeoutId);
            const contentType = response.headers.get("Content-Type");
            const transactionTimestamp = response.headers.get("X-Transaction-Timestamp");
            let rspBody = null;
            const error = null;
            if (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/json")) {
                rspBody = yield response.json();
            }
            else if (contentType === null || contentType === void 0 ? void 0 : contentType.includes("text/plain")) {
                rspBody = yield response.text();
            }
            else if (contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/octet-stream")) {
                rspBody = yield constructBufferResponseBody(response);
            }
            return createResponseObject(error, response.status, rspBody, transactionTimestamp);
        }
        catch (error) {
            logger.error(error.message);
            return createResponseObject(error, null, null);
        }
    });
}
function constructBufferResponseBody(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const contentType = response.headers.get("content-type");
        if (contentType === "application/octet-stream") {
            const responseBuffer = yield response.arrayBuffer();
            const buffer = buffer_1.Buffer.from(responseBuffer);
            return (0, serialization_1.decodeValue)(buffer);
        }
        if (contentType === "application/json") {
            return yield response.json();
        }
        const responseText = yield response.text();
        return responseText ? responseText : response.statusText;
    });
}
/**
 * Sends request to post data to a given API endpoint.
 * @param path API endpoint of Rell backend
 * @param endpoint
 * @param timeout
 * @param requestBody request body
 */
function post(path, endpoint, timeout, requestBody) {
    return __awaiter(this, void 0, void 0, function* () {
        logger.debug(`POST URL ${new URL(path, endpoint).href}`);
        logger.debug(`POST body ${JSON.stringify(requestBody)}`);
        if (buffer_1.Buffer.isBuffer(requestBody)) {
            try {
                const { controller, timeoutId } = createTimeoutController(timeout);
                const requestOptions = {
                    method: "post",
                    body: new Uint8Array(requestBody),
                    headers: {
                        Accept: "application/octet-stream",
                        "Content-Type": "application/octet-stream",
                    },
                    signal: controller === null || controller === void 0 ? void 0 : controller.signal,
                };
                const response = yield fetch(new URL(path, endpoint).href, requestOptions);
                if (timeoutId)
                    clearTimeout(timeoutId);
                const transactionTimestamp = response.headers.get("X-Transaction-Timestamp");
                return createResponseObject(null, response.status, yield constructBufferResponseBody(response), transactionTimestamp);
            }
            catch (error) {
                return createResponseObject(error, null, null);
            }
        }
        else {
            try {
                const { controller, timeoutId } = createTimeoutController(timeout);
                const response = yield fetch(new URL(path, endpoint).href, {
                    method: "post",
                    body: JSON.stringify(requestBody),
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    signal: controller === null || controller === void 0 ? void 0 : controller.signal,
                });
                if (timeoutId)
                    clearTimeout(timeoutId);
                const transactionTimestamp = response.headers.get("X-Transaction-Timestamp");
                return createResponseObject(null, response.status, yield constructBufferResponseBody(response), transactionTimestamp);
            }
            catch (error) {
                return createResponseObject(error, null, null);
            }
        }
    });
}
function createResponseObject(error, statusCode, rspBody, transactionTimestamp) {
    let finalStatusCode = statusCode;
    // Handle browser network errors as a specific status code for smart timeout logic
    if (error && !statusCode && !rspBody) {
        finalStatusCode = 502; // Treat as Bad Gateway for timeout purposes
    }
    const responseObject = {
        error,
        statusCode: finalStatusCode,
        rspBody,
    };
    if (transactionTimestamp) {
        responseObject.transactionTimestamp = transactionTimestamp;
    }
    return responseObject;
}
//# sourceMappingURL=httpUtil.js.map